// 對同一台設備的 RPC 一次一個（多路同步的本地來源，SPEC PLAY-03；app/vms#25）：2026-10-22 dev 同步頁一載入就對 lstw-16ch 同時送
// pb.days ×2 + pb.timeline ×3，設備一個都沒在 15 秒內回（504）、façade 還擋了一個（429 RATE_LIMITED）。同一個 key 的工作照順序跑，
// 前一個失敗不影響下一個。
const tails = new Map<string, Promise<unknown>>();

export function serialByHost<T>(key: string, job: () => Promise<T>): Promise<T> {
  const prev = tails.get(key) ?? Promise.resolve();
  const run = prev.then(job, job);
  const tail = run.catch(() => undefined);
  tails.set(key, tail);
  void tail.then(() => {
    if (tails.get(key) === tail) tails.delete(key);
  });
  return run;
}
